import BorderBottom from "./borderBottom";
import TypingParagraph from "./typingParagraph";

export default function First() {
  return (
    <>
      <div className="w-full h-full text-center lg:w-1/2">
        <p className="pb-2 mt-[10%] text-slate-800 font-thin font-serif text-4xl lg:mt-[20%] xl:text-5xl 2xl:text-6xl">
          Hi there, my name is
        </p>
        <TypingParagraph
          text="Larissa Perinoto =]"
          className="text-4xl xl:text-5xl 2xl:text-6xl"
        />
        <p className="py-6 font-mono text-slate-800 text-xl lg:text-2xl xl:text-3xl lg:py-8 2xl:text-4xl 2xl:py-10">
          Software Engineer
        </p>
        <BorderBottom
          title={"Request CV"}
          link="mailto:perinotolarissa@gmail.com?subject=cv request&body=Hello, I saw your website and I would like to know more about your professional background. My name is (insert your name here) and I work for the company (insert your company name here). Could you send me your CV?"
          className="lg:text-xl animate-slideInFromBottom"
        />
      </div>
      <div className="h-full w-full flex justify-center items-center lg:w-1/2 lg:justify-start">
        <div className="relative w-[65%] mt-6 md:w-[50%] lg:w-[50%] animate-slideInFromRight">
          {/* offset backing frames for a stacked, layered depth effect */}
          <div className="absolute -top-5 -left-5 w-full h-full border-2 border-black" />
          <div className="absolute -bottom-5 -right-5 w-full h-full border-2 border-emerald-500" />
          <div className="absolute top-1/2 -left-8 w-16 h-0.5 bg-black hidden md:block" />
          <div className="absolute -top-2 -right-2 w-3 h-3 rounded-full bg-emerald-500 z-10 animate-pulse" />

          {/* photo frame */}
          <div className="relative p-2 border-2 border-black bg-white shadow-xl">
            <div className="p-3 border-2 border-black bg-white flex justify-center">
              <img
                width="100%"
                height="auto"
                src="/profile.jpg"
                alt="Larissa Perinoto"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
